"use strict";

exports.__esModule = true;
var areComponentsEqual = exports.areComponentsEqual = function areComponentsEqual(a, b) {
  return a === b;
};
var setConfig = exports.setConfig = function setConfig() {};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-hot-loader/lib/prod/utils.prod.js
// module id = 145
// module chunks = 0